import en from './en';

const locale = {
  'en-US': en,
};

export default locale;
